module.exports = __webpack_public_path__ + "static/media/landing-background.671adda2.png";